"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ReduxFormField;

var _react = _interopRequireDefault(require("react"));

var _Checkbox = _interopRequireDefault(require("../Checkbox"));

var _TextField = _interopRequireDefault(require("../TextField"));

var _Select = _interopRequireDefault(require("../Select"));

var _excluded = ["input", "type", "meta", "options"],
    _excluded2 = ["value"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ReduxFormField(props) {
  var input = props.input,
      type = props.type,
      _props$meta = props.meta,
      touched = _props$meta.touched,
      error = _props$meta.error,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      rest = _objectWithoutProperties(props, _excluded);

  var fieldProps = _objectSpread({
    onBlur: input.onBlur,
    onFocus: input.onFocus,
    onChange: input.onChange,
    error: touched && error ? error : "",
    value: input.value
  }, rest);

  switch (type) {
    case "checkbox":
      {
        var value = fieldProps.value,
            checkboxProps = _objectWithoutProperties(fieldProps, _excluded2);

        return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], _extends({}, checkboxProps, {
          checked: !!value
        }));
      }

    case "select":
      return /*#__PURE__*/_react["default"].createElement(_Select["default"], _extends({}, fieldProps, {
        error: !!fieldProps.error,
        helperText: fieldProps.error,
        options: options
      }));

    default:
      {
        return /*#__PURE__*/_react["default"].createElement(_TextField["default"], _extends({}, fieldProps, {
          error: !!fieldProps.error,
          helperText: fieldProps.error
        }));
      }
  }
}